import { gql } from '@apollo/client';

export const GET_INSTITUTION = gql`
  query getInstitution($searchTerm: String, $id: ID) {
    institution: getInstitution(searchTerm: $searchTerm, id: $id) {
      id

      addressee
      ageRange0To18Months
      ageRange18MonthsTo3Years
      ageRange3To4Years
      ageRange4To5Years
      ageRange5To6Years
      allocation
      appliedForEcdEsrf
      areaOffice {
        id
        name
      }
      assessedForMaintenanceGrant
      certificateNumber
      classification
      componentNumber
      dateEcdEsrfReceived
      duplicateAction
      duplicateReference
      ecdServiceType
      educatorNumber
      emisNumber
      schoolEmmisNumber
      exDept
      examCentre
      examNumber
      expiryDate
      facsimile
      fundedThroughConditionalGrant
      fundedThroughEquitableShare
      gisAltitude
      gisLatitude
      gisLongitude
      gisSource
      gradeROffered
      identifiedBy
      identifiedDate
      isArchived
      issueDate
      learnerNumber
      locality
      monthlyFeeRangeHighest
      monthlyFeeRangeLowest
      name
      nas
      nearestPointOfInterest
      newEmisNumber
      newOrRenewal
      noFeeSchool
      nodalArea
      npoNumber
      numberOfChildrenEnrolled
      numberOfChildrenFunded
      numberOfStaff
      officeContactNumber
      officeEmailAddress
      oldEmisNumber
      organisationName
      networkName
      openBoardingSchool
      ownerBuild
      ownerLand
      ownership
      paypointNumber
      pcrLevel
      physicalAddress
      pointOfInterest
      postalAddress
      postalCode
      privateOrNpo
      progCertificateExpiryDate
      progCertificateIssueDate
      progCertificateNumber
      progLevel
      progStatus {
        id
        name
      }
      provinceCD
      quintile
      reasonForDuplicateAction
      receivedEcdEsrf
      receivedMaintenanceGrant
      registrationDate
      registrationNumber
      registrationOffice {
        id
        isInstitution
        isServiceProvider
        institution {
          id
          name
        }
        serviceProvider {
          id
          name
        }
      }
      registrationStatus {
        id
        name
      }
      section21
      section21Function
      specialization
      status
      streetAddress
      streetNo
      suburb
      townCity
      townshipVillage
      streetBuilding
      area
      verified
      validated
      wardID
      wardLabel
      year
      yearOfReceipt
      languageOfLearning
      closingTime
      openingTime
      afterCareForSchoolGoing
      primarySchoolName
      primarySchoolEmis
      isEcdServicePrimarySchoolBased
      hasHolidays
      numberOfDaysServiceOperate
      yearEcdStartedOperating
      legalEntity
      registeredAsNpo

      alternativeContactPerson {
        id
        designation
        name
        lastName
        contactNumber
        emailAddress
      }
      contactPerson {
        id
        designation
        name
        lastName
        contactNumber
        emailAddress
      }
      circuit {
        id
        name
      }
      country {
        id
        name
      }
      district {
        id
        name
      }
      districtMunicipality {
        id
        name
      }
      fundingClassification {
        id
        name
      }
      interventions {
        id
        name
      }
      localMunicipality {
        id
        localMunicipality
        localMunicipalityShorthand
      }
      ministry {
        id
        name
      }
      organisationUsersAddOns {
        id
        name
      }
      organisationUsersPlan {
        id
        name
      }
      personInCharge {
        id
        firstName
        lastName
        contactNumber
        email
      }
      phase {
        id
        name
      }
      province {
        id
        name
      }
      registrationType {
        id
        name
      }
      schoolType {
        id
        name
      }
      sector {
        id
        name
      }
      socialServicesProfessional {
        id
        firstName
        lastName
      }
      specializationGroup {
        id
        name
      }
      sspSupervisor {
        id
        firstName
        lastName
      }
      type {
        id
        name
      }
      communityType {
        id
        name
      }
      suburbRelation {
        id
        name
      }
      nutrition {
        id
        year
        mealsProvided
        foodProvider
        foodProviderOther
      }
      ecdFinanceDetails {
        id
        year
        fundedThroughConditionalGrant
        fundedThroughEquitableShare
        fundedThroughTopUpSubsidy
        monthlyFeeRangeHighest
        monthlyFeeRangeLowest
        assessedForMaintenanceGrant
        receivedMaintenanceGrant
        feesCharged
        numChildrenSubsidisedCG
        numChildrenSubsidisedES
        numChildrenSubsidisedTU
        mainFundingSource
        bankAccount
        receivesDBESubsidy
        monthlyESBudgetTotal
        monthlyCGBudgetTotal
        monthlyTopUpSubsidyTotal
        infrastructureGrantBudget
      }
      ecdEnrolmentData {
        id
        year
        viewOption
        gradeROffered
        registeredCapacity
        gradeR
        numberOfMales
        numberOfFemales
        numberEnrolledWithDisabilities
        numberOfAfricanBlack
        numberOfColoured
        numberOfIndianAsian
        numberOfWhite
        numberOfOther
        ageRange0To18Months
        ageRange18MonthsTo3Years
        ageRange3To4Years
        ageRange4To5Years
        ageRange5To6Years
        ageRange0To12Months
        ageRange1To2Years
        ageRange2To3Years
        numberOfChildrenEnrolled
        gradeRMales
        gradeRFemales
        numberOfAfricanBlackMales
        numberOfAfricanBlackFemales
        numberOfColouredMales
        numberOfColouredFemales
        numberOfIndianAsianMales
        numberOfIndianAsianFemales
        numberOfWhiteMales
        numberOfWhiteFemales
        numberOfOtherMales
        numberOfOtherFemales
        ageRange0To18MonthsMales
        ageRange0To18MonthsFemales
        ageRange18MonthsTo3YearsMales
        ageRange18MonthsTo3YearsFemales
        ageRange3To4YearsMales
        ageRange3To4YearsFemales
        ageRange4To5YearsMales
        ageRange4To5YearsFemales
        ageRange5To6YearsMales
        ageRange5To6YearsFemales
        ageRange0To12MonthsMales
        ageRange0To12MonthsFemales
        ageRange1To2YearsMales
        ageRange1To2YearsFemales
        ageRange2To3YearsMales
        ageRange2To3YearsFemales
      }
      ecdStaffData {
        id
        year
        viewOption
        paid
        unpad
        female
        male
        genderOther
        gradeREducators
        ecdPractitioners
        managerialStaff
        supportStuff
        fullTime
        partTime
        accreditedECDSkillsProgram
        nqfLevel4to5ECD
        nqfLevel6to9ECD
        unaccreditedECDSkills
        numberOfStaff
        fullTimeMales
        fullTimeFemales
        fullTimeGenderOther
        partTimeMales
        partTimeFemales
        partTimeGenderOther
      }
      ecdFacilityDetail {
        id
        landowner
        landownerOther
        buildingOwner
        buildingOwnerOther
        building
        buildingOther
        sharedBuilding
        numberOfClassrooms
        kitchen
        separateRoomAsOffice
        outdoorPlayArea
        fence
        gate
        outdoorEquipment
        whatHandwashingFacility
        mainSourceOfPowerLighting
        mainSourceOfPowerCooking
        mainSourceOfPowerHeating
        mainSourceOfWater
        mainSourceOfWaterOther
        separateToilets
        childrenToilets
        adultToilets
        numToilets
        typesOfToilets
      }
      organisation {
        contactList {
          id
          firstName
          lastName
          designation
          countryCode
          contactNumber
          emailAddress
          linkedin
          personInCharge
          primaryContact
          personnelPositionOther
          personnelPosition {
            id
            name
          }
        }
      }
    }
  }
`;
